import { render, staticRenderFns } from "./HomeForum.vue?vue&type=template&id=25f5d014&scoped=true&"
import script from "./HomeForum.vue?vue&type=script&lang=js&"
export * from "./HomeForum.vue?vue&type=script&lang=js&"
import style0 from "./HomeForum.vue?vue&type=style&index=0&id=25f5d014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5d014",
  null
  
)

export default component.exports